import { useTranslation } from 'react-i18next'

interface TranslationOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export const t = (key: string, options?: TranslationOptions) => {
  const { t } = useTranslation()

  // Check if the translation key exists
  if (t(key) === key && options !== undefined && options.default == null) {
    // Key doesn't exist, return the default message
    return `No translation for "${key}"`
  }

  // Key exists, use the provided translation
  return t(key, options)
}
